import React, { useRef, useEffect, useState } from 'react'
import Navbar from '../Navbar'
import { Link, NavLink } from 'react-router-dom';
import Footer from '../Footer';

// 151515

export default function FormCV1() {
  document.body.style = 'background: white;';

// const data = useRef();

// const handleChange=()=>{
//   localStorage.setItem("firstName",data.current.value)
//   let last = document.getElementById("lastname")
//   last.value= localStorage.getItem("firstName")
// }

    const cvfname = useRef();
    const cvlname = useRef();
    const cvphn = useRef();
    const cveid = useRef();
    const cvadd = useRef();
    const cvcity = useRef();
    const cvpcode = useRef();
    const cvstate = useRef();
    const cvcountry = useRef();
    const cvjobtitle = useRef();
    
    const [profileImg, setprofileImg] = useState(null)

    const handleChange=()=>{
      const personalDetails = {
      "firstname": cvfname.current.value,
      "lastname": cvlname.current.value,
      "phone": cvphn.current.value,
      "email": cveid.current.value,
      "address": cvadd.current.value,
      "city": cvcity.current.value,
      "postcode": cvpcode.current.value,
      "state": cvstate.current.value,
      "country": cvcountry.current.value,
      "jobtitle": cvjobtitle.current.value
    }
    localStorage.setItem("personalDetails", JSON.stringify(personalDetails))
  }

  useEffect(() => {
    if (localStorage.getItem("personalDetails")) {
        const personalDetails = JSON.parse(localStorage.getItem("personalDetails"));
        if (personalDetails !== null) {
            cvfname.current.value = personalDetails.firstname;
            cvlname.current.value = personalDetails.lastname;
            cvphn.current.value = personalDetails.phone;
            cveid.current.value = personalDetails.email;
            cvadd.current.value = personalDetails.address;
            cvcity.current.value = personalDetails.city;
            cvpcode.current.value = personalDetails.pcode;
            cvstate.current.value = personalDetails.state;
            cvcountry.current.value = personalDetails.country;
            cvjobtitle.current.value = personalDetails.jobtitle;
      

            const img = localStorage.getItem("profilePhoto")
            setprofileImg(img);

        } else {
            console.warn("value not present ")

        }
    }
}, [])

     //image upload
     const handlePhotoUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
          const reader = new FileReader();

          reader.onload = (e) => {
              const imageDataUrl = e.target.result;
              localStorage.setItem('profilePhoto', imageDataUrl);
              const img = localStorage.getItem("profilePhoto")
              setprofileImg(img);
          }

          reader.readAsDataURL(file);
      }
  };

  return (
    <div className="App" style={{}}>
      <Navbar theme={"dark"} bgcolor={"#151515"}/>
    
    <div style={{height:"950px",backgroundColor:"white", border:"2px solid white"}}>

      <div style={{fontFamily:"Questrial", marginTop:"50px"}}>
        <h2>Personal Details</h2>
      </div>

      <div class="container text-center " style={{width:"800px",marginTop:"30px"}}>
      <div class="row row-cols-2">

    <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvfname} type="text" class="form-control" id="idfirstname" placeholder="First Name"/></div>

    <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvlname} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Last Name"/></div>

    <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvphn} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Phone"/></div>

    <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cveid} type="email" class="form-control" id="exampleFormControlInput1" placeholder="Email Address"/></div>
  </div>
   
  
  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvadd} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Address"/></div>

   <div class="row row-cols-2">

  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvcity} type="text" class="form-control" id="exampleFormControlInput1" placeholder="City"/></div>

  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvpcode} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Postcode"/></div>

  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvstate} type="text" class="form-control" id="exampleFormControlInput1" placeholder="State"/></div>

  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvcountry} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Country"/></div>
  </div>
  
  <div class="col"><label for="exampleFormControlInput1" class="form-label"></label>
  <input ref={cvjobtitle} type="text" class="form-control" id="exampleFormControlInput1" placeholder="Job Title"/></div>

  {/* <div class="mb-3" style={{marginTop:"30px"}}>
  <label for="exampleFormControlTextarea1" class="form-label" style={{fontFamily:"Questrail", fontSize:"16px", fontStyle:"italic"}}>Personal Summary</label>
  <textarea ref={cvpersumm} class="form-control" id="exampleFormControlTextarea1" rows="3" placeholder='Personal Summary...' style={{height:"300px"}}></textarea>
</div> */}

<div class="mb-3" style={{ marginTop: "20px" }}>
                        <label for="formFile" class="form-label" style={{ fontFamily: "Questrail", fontSize: "16px", fontStyle: "italic" }}>Upload your photo <span>  Note :Image size should be 1:1.</span></label>
                        <input class="form-control" type="file" accept='image/*' onChange={handlePhotoUpload} id="formFile" />
                    </div>
                    <div style={{width:"100%" , display:"flex" , alignItems:"center" , justifyContent:"center"}} ><img src={profileImg} alt="" height="100" style={{height:"150px"}} /></div>

</div>
  <div style={{display:"flex", justifyContent:"center", marginTop:"40px", fontFamily:"kanit"}}> 

   <Link to="/"  class="btn btn-outline-danger" style={{marginRight:"50px", width:"180px",fontSize:"18px"}}>Back</Link>

   <Link to="/formcv2" onClick={handleChange} class="btn btn-outline-success" style={{width:"180px",fontSize:"18px"}}>Next</Link>
  </div>

  {/* <button onClick={handleChange} type="button" class="btn btn-primary">Submit</button> */}

</div>

<Footer/>
    </div>
  )
}
